/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Size, ButtonVariant, Tooltip } from "@blueprintjs/core"
import { ID } from "src/libs/interfaces/layouts"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { IPanelConsole } from "./interface"
import Panel from "./Panel"
import PanelConsoleHandler from "./PanelConsoleHandler"
import { allPanelData } from "./PanelLayout"
import { __ } from "src/libs/utilities"

/* Protopia Ecosystem component */ 
export interface IPanelConsoleProps {
    data: IPanelConsole
    onPosition: ( x:number, y: number, w: number, h: number, panelId: ID, consoleId: ID ) => void
    setActivePanelDataId: (panelDataId: ID, panelId: ID) => void
    onThread: (panelId: ID, consoleId: ID, isTread: boolean, x:number, y: number, w: number, h: number, ) => void
    onCompact: ( panelId: ID, isCompact: boolean ) => void
    onClose: ( panelId: ID ) => void
    onConsoleClose: (id: ID, isOpen: boolean) => void
}
const PanelConsole = (props: IPanelConsoleProps ): JSX.Element => {
    const { width, panels, id } = props.data  
    const console_width = useSyncState<number>( width ) 

    const setConsoleWidth = (width: number) => {
        console_width.set( width )
    }
    const updateConsoleWidth = () => { 
        // useLandingConsoleStore.setState({ width: console_width.get() })
    } 
    const onPosition = ( x:number, y: number, w: number, h: number, id: ID ) => {
        props.onPosition( x, y, w, h, id, props.data.id )
    }
    const onThread = (panelId: ID, consoleId:ID, _isTread: boolean, x:number, y: number, w: number, h: number, ) => {
        props.onThread(panelId, consoleId, _isTread, x, y, w, h )
    }
    const onCompact = (panelId: ID, isOpen: boolean ) => {
        
        console.log("Panel Console:", isOpen)
        
        props.onCompact(panelId, isOpen)
    }
    const realWidth = props.data.isOpen ? console_width.get() : 60 
    return <div className="pe-console-panel" style={{ width: realWidth, minWidth: realWidth, }} data-console-id={ id }>
        <PanelConsoleHandler 
            console_width={ console_width.get() } 
            setConsoleWidth={ setConsoleWidth } 
            updateConsoleWidth={updateConsoleWidth}
        />
        <div className="pe-console-panel-content " style={{width: realWidth - 8, minWidth: realWidth - 8, }}>
            <div className="d-flex w-100">
                <Tooltip 
                    content={ <div className="small letter-spacing-1">{__( props.data.isOpen ? "Do compact" : "Do wide" )}</div> } 
                    className=" ml-auto" position="bottom-right"
                    compact
                    hoverOpenDelay={600}
                    portalClassName="z-index-90"
                    modifiers={{ 
                        arrow: { enabled: true },
                        flip: { enabled: true },
                        preventOverflow: { enabled: false },
                        offset: { 
                            enabled: true, 
                            options: {
                                offset: [0, 4],
                            } 
                        }, 
                    }}
                >
                    <Button size={ Size.SMALL } variant={ ButtonVariant.MINIMAL } className="ml-auto" onClick={ () => props.onConsoleClose(props.data.id, !props.data.isOpen) }>
                        <div className="small">
                        
                                <i className={`fas ${!!props.data.isOpen ? "fa-long-arrow-alt-right" : "fa-arrows-alt-h"} text-light opacity_5`} /> 
                        </div>
                    </Button>
                </Tooltip>
            </div>
            
            
            {
                panels.map(panel => { 
                    return <Panel
                        key={ panel.id }
                        id={ panel.id }
                        activeId={ panel.activeId || panel.panelDatas[0]?.id }
                        data={
                            panel.panelDatas.map( pd => {  
                                return {
                                    id: pd.id,
                                    title: pd.title,
                                    icon: pd.icon,
                                    data: allPanelData()[ pd.id ]?.component || <></>
                                }
                            })
                        }
                        isConsoleOpen={props.data.isOpen}
                        onClose={() => props.onClose( panel.id ) }
                        onThread={onThread}
                        onCompact={onCompact}
                        isTread= { panel.isTread }
                        isOpen={ panel.isOpen } 
                        x={ panel.x }
                        y={ panel.y }
                        w={ panel.w }
                        h={ panel.h }
                        setActiveId={(panelDataId: ID) => props.setActivePanelDataId(panelDataId, panel.id)}
                        onPosition={ ( x:number, y: number, w: number, h: number ) => onPosition( x, y, w, h, panel.id )}
                    />
                })
            }
            
        </div>
        
    </div>
}
export default PanelConsole
 